import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const ExpenseTxnServices = {
  create: async (data) => {
    const response = await apiService.post(
      `/${slug}/transactions/createtxn`,
      data
    );
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/transactions/getalltxn`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/purchase/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(`/${slug}/transactions/update/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/transactions/delete/${id}`);
    return response.data;
  },
};

export default ExpenseTxnServices;
